let publicKey = null;

// Convert PEM to binary (ArrayBuffer)
const pemToArrayBuffer = (pem) => {
    const b64Lines = pem.replace(/(-----(BEGIN|END) PUBLIC KEY-----|\n|\r)/g, "");
    const str = atob(b64Lines);
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i += 1) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
};

export const setPublicKey = async (pemKey) => {
    try {
        const binaryKey = pemToArrayBuffer(pemKey);
        publicKey = await window.crypto.subtle.importKey(
            "spki",
            binaryKey,
            {
                name: "RSA-OAEP",
                hash: "SHA-256",
            },
            false, // non-extractable
            ["encrypt"]
        );
    } catch (e) {
        console.error("Error importing public key:", e);
    }
};

export const encryptPayload = async (data) => {
    if (!publicKey) {
        console.error("Public key not set for encryption");
        return null;
    }
    try {
        const enc = new TextEncoder();
        const encodedData = enc.encode(JSON.stringify(data));

        const encrypted = await window.crypto.subtle.encrypt(
            {
                name: "RSA-OAEP",
                hash: "SHA-256",
            },
            publicKey,
            encodedData
        );

        // Convert ArrayBuffer to Base64
        let binary = "";
        const bytes = new Uint8Array(encrypted);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i += 1) {
            binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
    } catch (e) {
        console.error("Encryption error:", e);
        return null;
    }
};
